var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"pmis-title",attrs:{"align":"center"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',{attrs:{"id":"pmis-subtitle"}},[_vm._v("SRIP pametna mesta in skupnosti")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }